/**
 * External dependencies
 */
import { registerBlockType } from '@wordpress/blocks';
import { Icon, box } from '@wordpress/icons';

/**
 * Internal dependencies
 */
import { Edit, Save } from './edit';
import metadata from './block.json';
import { getSetting } from '@woocommerce/settings';


const cfeSettings = getSetting('thwcfe-block-integration_data', '');
const { allSections } = cfeSettings;
const { contact } = allSections;

const updatedMetadata = {
    ...metadata,
    attributes: {
        ...metadata.attributes,
        sectionData: {
            type: 'object',
            default: contact,
        },
    },
};

registerBlockType( updatedMetadata, {
	
	icon: {
		src: <Icon icon={ box } />,
	},
	edit: Edit,
	save: Save,
} );
